var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketship(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "84778FF0-9E20-4EDE-9670-BB9DF229ECA9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 59.9998 0 59.9998 59.99995 0 59.99995"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Help-Page_V3",
    transform: "translate(-545.000000, -579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(513.000000, 547.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rocketship",
    transform: "translate(32.000200, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,-5.00000001e-05 C13.431,-5.00000001e-05 0,13.43145 0,29.99995 C0,46.56895 13.431,59.99995 30,59.99995 C46.5685,59.99995 60,46.56895 60,29.99995 C60,13.43145 46.5685,-5.00000001e-05 30,-5.00000001e-05 M30,1.49995 C45.715,1.49995 58.5,14.28495 58.5,29.99995 C58.5,45.71495 45.715,58.49995 30,58.49995 C14.2845,58.49995 1.5,45.71495 1.5,29.99995 C1.5,14.28495 14.2845,1.49995 30,1.49995",
    id: "Fill-1",
    fill: "#EDEBE9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(16.999800, 10.000000)",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.48895,4.84515 C12.50095,4.82865 12.51445,4.81215 12.52595,4.79515",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.48895,4.84515 C12.44095,4.90865 12.39145,4.97265 12.34445,5.03615 C10.36395,7.73015 7.41895,9.92865 0.71595,11.57165",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.716,11.5715 C0.7135,11.572 0.7105,11.573 0.708,11.5735",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.20085,3.9892 C11.20835,3.9797 11.21685,3.9672 11.23185,3.9462",
    id: "Stroke-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6208,9.9997 C0.6023,10.0042 0.5853,10.0092 0.5663,10.0137",
    id: "Stroke-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.20085,3.9892 C11.18235,4.0142 11.18135,4.0107 11.13985,4.0682 C9.21985,6.7072 7.09635,8.3902 0.62085,9.9997",
    id: "Stroke-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.51095,26.9072 C25.05895,31.1512 24.78695,38.5397 24.77295,38.8727 L24.74195,39.6302 L24.08145,39.2577 C23.79445,39.0957 17.46045,35.4907 14.87645,31.3702",
    id: "Stroke-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.14765,29.5202 C13.15565,29.5242 13.16265,29.5287 13.17065,29.5332 L12.92165,31.8522 L13.53765,31.7332 C13.60165,31.7212 14.09615,31.6217 14.87665,31.3702",
    id: "Stroke-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.14765,29.5202 C12.66015,29.2577 12.18615,28.9862 11.72565,28.7052",
    id: "Stroke-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7668,22.92865 C21.7793,23.46815 21.7773,24.01465 21.7608,24.56865 L23.8518,25.58765 L23.4023,26.04765 C23.1078,26.34915 22.8098,26.63565 22.5108,26.90715",
    id: "Stroke-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.48895,4.84515 L12.60145,4.92315 L12.59745,4.92815 C12.67845,4.98665 12.75895,5.04515 12.83895,5.10515 L12.84295,5.10015 L13.22345,5.39365 C13.22395,5.39415 13.22395,5.39415 13.22445,5.39465 L13.57795,5.66815 L13.57445,5.67265 C16.05645,7.66515 18.00695,10.05165 19.37445,12.77365 C19.86345,13.74815 20.27845,14.76665 20.61895,15.82665",
    id: "Stroke-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7668,22.92865 C23.3948,22.47065 27.7138,23.65365 30.2323,24.57665 L31.4338,25.01715 L30.7938,23.90865 C27.5728,18.32965 24.1873,16.53815 21.9143,16.01765 C21.4543,15.91265 21.0213,15.85365 20.6188,15.82665",
    id: "Stroke-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.72575,28.70505 C10.49425,29.79105 9.35675,34.20905 8.90775,36.88605 L8.69425,38.16005 L8.04825,37.04105 C4.82725,31.46305 4.95425,27.64355 5.62825,25.42255 C5.77375,24.94305 5.94875,24.51605 6.13775,24.13755 C5.40275,23.32405 4.73875,22.46855 4.14925,21.57155 C2.47675,19.03055 1.38525,16.15305 0.89875,13.01355 L0.89275,13.01455 L0.82975,12.54905 L0.82975,12.54855 L0.76825,12.09455 L0.77475,12.09355 C0.76125,11.98155 0.74925,11.87005 0.73725,11.75755 L0.73175,11.75805 L0.71575,11.57155",
    id: "Stroke-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.20085,3.9892 C6.76135,1.2072 2.62785,0.4677 2.44135,0.4357 L2.06085,0.3697 L1.92685,0.7322 C1.86185,0.9087 0.45235,4.8112 0.62085,9.9997",
    id: "Stroke-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.716,11.5715 L0.692,11.281 L0.692,11.277 L0.6555,10.8325 L0.6605,10.832 C0.642,10.551 0.63,10.274 0.621,9.9995",
    id: "Stroke-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.20085,3.9892 C11.41135,4.1212 11.62235,4.2557 11.83385,4.3967 L11.83635,4.3937 L12.19335,4.6407 C12.19435,4.6412 12.19485,4.6417 12.19585,4.6422 L12.48885,4.8452",
    id: "Stroke-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.51095,26.9072 C21.78195,27.7012 17.37295,30.7852 14.87645,31.3702",
    id: "Stroke-36"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.14765,
    y1: 29.5202,
    x2: 13.14715,
    y2: 29.5207,
    id: "Stroke-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.14765,29.5202 C14.20065,27.9982 19.32565,24.7687 21.70565,24.5687",
    id: "Stroke-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18865,24.1948 C6.18865,24.1948 9.75715,27.6518 11.72565,28.7053",
    id: "Stroke-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5046,18.39765 C14.2541,17.38765 14.8531,15.15065 13.8436,13.40115 C12.8331,11.65165 10.5966,11.05215 8.8471,12.06215 C7.0976,13.07215 6.4976,15.30915 7.5081,17.05865 C8.5176,18.80815 10.7551,19.40765 12.5046,18.39765 Z",
    id: "Stroke-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.61885,15.82685 C20.61885,15.82685 21.80285,20.96685 21.76685,22.92885",
    id: "Stroke-46"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketship);
export default __webpack_public_path__ + "static/media/rocketship.207173735af7cc27bbd5a645dbd5512e.svg";
export { ForwardRef as ReactComponent };